import { moneyStringToNumber } from "utils/currency";
import {
  CARD_DETAILS_CONSTANTS,
  CARD_TYPES,
  DELIVERY_AND_REDEMPTION_INSTRUCTIONS,
  TOOLTIP_CONSTANTS
} from "./constants";

const getCardTypeDetails = ({ cardType }) => {
  const cardTypes = [];

  const deliveryType = {
    egift: cardType.electronic_online,
    voucher: cardType.electronic_voucher,
    physical: cardType.physical
  };

  const details = Object.assign({}, CARD_DETAILS_CONSTANTS, {
    deliveryAndRedemption: []
  });

  if (cardType.electronic_online) {
    cardTypes.push({
      content: CARD_TYPES.EGIFT,
      toolTip: TOOLTIP_CONSTANTS.egift
    });
    details.deliveryAndRedemption.push(
      DELIVERY_AND_REDEMPTION_INSTRUCTIONS.egift
    );
  }

  if (cardType.electronic_voucher) {
    cardTypes.push({
      content: CARD_TYPES.VOUCHER,
      toolTip: TOOLTIP_CONSTANTS.voucher
    });
    details.deliveryAndRedemption.push(
      DELIVERY_AND_REDEMPTION_INSTRUCTIONS.voucher
    );
  }

  if (cardType.electronic_voucher || cardType.electronic_online) {
    details.deliveryAndRedemption.push(
      DELIVERY_AND_REDEMPTION_INSTRUCTIONS.eletronicOrVoucher
    );
  }

  details.deliveryAndRedemption.push(cardType?.instructions);

  return { cardTypes, details, deliveryType };
};

const getCardsWithDetails = ({ card_details }) => {
  const { brandInfo, discount, cardValue, terms, uuid, listing_uuid } =
    JSON.parse(card_details);
  const { name, src, cardType } = brandInfo;

  const cardTypeWithDetails = getCardTypeDetails({
    cardType
  });

  const cardWithDetails = {
    uuid,
    listingUuid: listing_uuid,
    name,
    discount,
    imageSrc: src,
    cardType: cardTypeWithDetails,
    cardValue,
    terms
  };

  return cardWithDetails;
};

const toCardsWithDetails = (cards, brandSlug) => {
  return cards.map((singleCard) => {
    const { name, cardValue, discount, imageSrc, cardType, terms } = JSON.parse(
      singleCard.card_details
    );

    return {
      uuid: singleCard.uuid,
      listingUuid: singleCard.listing_uuid,
      brandUuid: singleCard.brand_uuid,
      userUuid: singleCard.user_uuid,
      name,
      discount,
      imageSrc,
      cardType,
      price: singleCard.price,
      value: cardValue,
      terms,
      brand_slug: brandSlug || singleCard.brand_slug
    };
  });
};

const getCardsValueNumber = (cards) => {
  const value = cards.reduce((acc, card) => {
    if (acc === null) {
      return acc;
    }

    try {
      const value = JSON.parse(card.card_details).cardValue;
      const valueNumber = moneyStringToNumber(value);

      if (typeof valueNumber !== "number") {
        throw Error;
      }

      acc += valueNumber;
      return acc;
    } catch (err) {
      acc = null;
    }

    return acc;
  }, 0);

  return value;
};

export { getCardsValueNumber, getCardsWithDetails, toCardsWithDetails };
